export const label = {
  'es-ES': 'Atrás',
  'es-US': 'Atrás',
  ar: 'الخلف',
  az: 'Geri',
  be: 'Назад',
  bg: 'Назад',
  bs: 'Nazad',
  cnr: 'Nazad',
  cs: 'Zpět',
  da: 'Tilbage',
  de: 'Zurück',
  el: 'Πίσω',
  en: 'Back',
  es: 'Atrás',
  et: 'Tagasi',
  fi: 'Takaisin',
  fr: 'Retour',
  he: 'חזור',
  hr: 'Natrag',
  hu: 'Vissza',
  hy: 'Հետ',
  id: 'Kembali',
  is: 'Til baka',
  it: 'Indietro',
  ja: '戻る',
  ka: 'უკან',
  ko: '뒤로',
  lt: 'Atgal',
  lv: 'Atpakaļ',
  mk: 'Назад',
  nl: 'Terug',
  no: 'Tilbake',
  pl: 'Wstecz',
  pt: 'Voltar',
  ro: 'Înapoi',
  ru: 'Назад',
  sk: 'Späť',
  sl: 'Nazaj',
  sq: 'Prapa',
  sr: 'Nazad',
  sv: 'Bakåt',
  th: 'ย้อนกลับ',
  tr: 'Geri',
  uk: 'Назад',
  vi: 'Quay lại',
  zh: '返回',
};
